// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VariantParametersSection-module__main--ln9Bm {
    --width: 142px;
    width: var(--width);
}

.VariantParametersSection-module__imageContainer--_NYML {
    width: var(--width);
    height: 134px;
    overflow: hidden;
    background-color: var(--color-general-background);
    border-radius: var(--border-radius);
    border: 2px solid var(--color-general-background);
}

.VariantParametersSection-module__imageContainer--_NYML.VariantParametersSection-module__currentVariant--fMq3h {
    border: 2px solid var(--color-general-black);
}

.VariantParametersSection-module__imageContainer--_NYML img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
`, "",{"version":3,"sources":["webpack://./src/dom/Demo/FurnitureInstanceDetails/VariantParametersSection.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,iDAAiD;IACjD,mCAAmC;IACnC,iDAAiD;AACrD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB","sourcesContent":[".main {\n    --width: 142px;\n    width: var(--width);\n}\n\n.imageContainer {\n    width: var(--width);\n    height: 134px;\n    overflow: hidden;\n    background-color: var(--color-general-background);\n    border-radius: var(--border-radius);\n    border: 2px solid var(--color-general-background);\n}\n\n.imageContainer.currentVariant {\n    border: 2px solid var(--color-general-black);\n}\n\n.imageContainer img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `VariantParametersSection-module__main--ln9Bm`,
	"imageContainer": `VariantParametersSection-module__imageContainer--_NYML`,
	"currentVariant": `VariantParametersSection-module__currentVariant--fMq3h`
};
export default ___CSS_LOADER_EXPORT___;
